import { render, staticRenderFns } from "./AdministrativePermitsPersonView.vue?vue&type=template&id=f8903ae2&scoped=true"
import script from "./AdministrativePermitsPersonView.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsPersonView.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsPersonView.vue?vue&type=style&index=0&id=f8903ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8903ae2",
  null
  
)

export default component.exports